<template>
  <section class="hero">
    <h1>{{ t("Développeuse fullstack JavaScript.", "Fullstack JavaScript developer.") }}</h1>
    <p v-if="lang === 'fr'" class="lead">
      Salut 👋🏾 je suis <b>Arolle Fona</b>, développeuse fullstack JavaScript basée à Douala, et co-fondatrice de
      <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a>, une communauté qui aide les
      femmes passionnées par la tech.
    </p>
    <p v-else class="lead">
      Hi 👋🏾 I'm <b>Arolle Fona</b>, a fullstack JavaScript developer based in Douala, and co-founder of
      <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a>, a community that supports
      women passionate about tech.
    </p>
    <SocialLinks />
  </section>

  <section class="sec first">
    <div class="grid-2">
      <div>
        <div class="sec-head">
          <h2><Folder />{{ t("Projets", "Projects") }}</h2>
        </div>
        <ProjectList :items="projects" />
        <p class="more">
          <router-link class="link" :to="to('projects')">{{ t("Voir tous les projets", "See all projects") }} <ArrowRight /></router-link>
        </p>
      </div>
      <aside class="card" aria-labelledby="xp-title">
        <div class="sec-head">
          <h2 id="xp-title"><Briefcase />{{ t("Parcours", "Experience") }}</h2>
        </div>
        <ul class="xlist">
          <li v-for="(x, i) in experiences" :key="i">
            <CompanyLogo :src="x.logo" :photo="x.photo" :position="x.position" :initials="x.initials" />
            <div>
              <div class="row"><b>{{ x.name }}</b><span>{{ t(x.dates) }}</span></div>
              <span>{{ t(x.role) }}</span>
            </div>
          </li>
        </ul>
        <div class="stack-btn">
          <router-link class="btn" :to="to('experience')">{{ t("Voir tout le parcours", "See full experience") }} <ArrowRight /></router-link>
          <a class="btn dark" :href="`mailto:${email}`">{{ t("Me contacter", "Get in touch") }}</a>
        </div>
      </aside>
    </div>
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><MonitorPlay />{{ t("À voir", "Watch") }}</h2>
      <router-link class="link" :to="to('community')">Community & Talks <ArrowRight /></router-link>
    </div>
    <VideoCard />
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><PenLine />{{ t("Derniers articles", "Latest articles") }}</h2>
      <router-link class="link" :to="{ path: to('about'), hash: '#ecrits' }">{{ t("Tous les articles", "All articles") }} <ArrowRight /></router-link>
    </div>
    <ArticleList :items="articles" />
  </section>
</template>

<script>
import { ArrowRight, Briefcase, Folder, MonitorPlay, PenLine } from "lucide-vue-next";
import ArticleList from "@/components/ArticleList.vue";
import CompanyLogo from "@/components/Logo.vue";
import ProjectList from "@/components/ProjectList.vue";
import SocialLinks from "@/components/SocialLinks.vue";
import VideoCard from "@/components/VideoCard.vue";
import { ARTICLES, EMAIL, EXPERIENCES, PROJECTS } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "HomePage",
  components: { ArrowRight, Briefcase, Folder, MonitorPlay, PenLine, ArticleList, CompanyLogo, ProjectList, SocialLinks, VideoCard },
  setup() {
    return {
      ...useI18n(),
      projects: PROJECTS.slice(0, 4),
      experiences: EXPERIENCES.slice(0, 6),
      articles: ARTICLES.slice(0, 3),
      email: EMAIL,
    };
  },
};
</script>

<style scoped>
.first {
  padding-top: 24px;
}
.more {
  margin-top: 28px;
}
.card .sec-head {
  margin-bottom: 20px;
}
</style>
